/**
 * Where these pages talk to. Every call is to a Supabase edge function with
 * the public (anon) key; no page holds a secret or queries a table.
 * `VITE_FUNCTIONS_URL` points the app at a stand-in server in tests.
 */
export const FUNCTIONS_URL = (import.meta.env.VITE_FUNCTIONS_URL || "https://aihtbtdmbqdmxcfyvqgn.supabase.co/functions/v1").replace(/\/+$/, "");

export const SUPABASE_ANON_KEY = "sb_publishable_KZvF8loOxIO3Wx1-clwZfA_MOs9yZr3";

/**
 * Turnstile's public site key, used when a form's configuration carries no
 * key of its own. Public by design — it is rendered into the widget markup.
 */
export const DEFAULT_TURNSTILE_SITE_KEY = "0x4AAAAAAE78LA62bBzhdiT4";
